import {
  Text,
  TableCellTitle,
  Table,
  TableBody,
  TableCell,
  UIPage,
  Pagination,
} from "@eventsquare/uikit";
import styles from "@styles/Orders.module.scss";
import { RiWalletLine } from "@remixicon/react";
import { ReactElement, useEffect, useState } from "react";
import dummyOrders from "@data/dummyOrders.json";
import { Order } from "@type/orders.ts";
import OrderDetailModal from "@components/OrderDetailModal/OrderDetailModal";
import { FilterBar, FilterSearch } from "@eventsquare/uikit/filters";
import bankcontact from "@assets/bancontact.svg";

const typedOrders: Order[] = dummyOrders;

const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    const isYesterday =
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();

    if (isToday) return "Today";
    if (isYesterday) return "Yesterday";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} at ${hours}:${minutes}`;
  } catch {
    return "Invalid Date";
  }
};

const renderPaymentMethodIcon = (paymentMethod: string): ReactElement => {
  if (paymentMethod === "Wallet") {
    return <RiWalletLine style={{ width: 24, height: 24 }} />;
  }

  return (
    <img
      src={bankcontact}
      style={{ width: 24, height: 24 }}
      alt="Bank Contact"
      className={styles.paymentMethodIcon}
    />
  );
};

const Orders = () => {
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [searchValue, setSearchValue] = useState("");
  const [activePage, setActivePage] = useState(1);

  useEffect(() => {}, [activePage]);

  const handleOpenModal = (order: Order) => {
    setSelectedOrder(order);
    setShowDetailModal(true);
  };

  const filteredOrders = typedOrders.filter((order) =>
    order.customer.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <UIPage noPadding>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.header}>
            <Text variant="h1" noMargin>
              Orders
            </Text>
            <FilterBar>
              <FilterSearch
                value={searchValue}
                setValue={(str) => setSearchValue(str)}
                placeholder="Search..."
              />
            </FilterBar>
          </div>
          <div className={styles.body}>
            <Table dataGrid>
              <colgroup className={styles.colGroup}>
                <col style={{ width: "25%" }} />
                <col style={{ width: "25%" }} />
                <col style={{ width: "25%" }} />
                <col style={{ width: "25%" }} />
              </colgroup>
              <TableBody>
                {filteredOrders.map((order) => (
                  <tr
                    className={styles.tableRow}
                    key={order.id}
                    onClick={() => handleOpenModal(order)}
                  >
                    <TableCell gridArea="wide1">
                      <TableCellTitle>
                        <Text variant="h5" noMargin>
                          {order.customer}
                        </Text>
                      </TableCellTitle>
                    </TableCell>
                    <TableCell gridArea="narrow1">
                      <Text variant="h5" noMargin>
                        {order.price}
                      </Text>
                    </TableCell>
                    <TableCell gridArea="narrow2">
                      <Text variant="small" noMargin>
                        Order #{order.id}
                      </Text>
                    </TableCell>
                    <TableCell gridArea="wide2" textAlign="center">
                      <Text variant="small" noMargin>
                        {formatDate(order.ordered_at)}
                      </Text>
                    </TableCell>
                  </tr>
                ))}
              </TableBody>
            </Table>
          </div>
          <div className={styles.footer}>
            <Pagination
              activePage={activePage}
              setActivePage={setActivePage}
              itemsPerPage={10}
              itemsTotal={200}
              translations={{
                back: "Back",
                next: "Next",
                active_page:
                  "Payout {{ firstItem }}-{{ lastItem }} from {{ totalItems }}",
              }}
            ></Pagination>
          </div>
        </div>
      </div>
      <OrderDetailModal
        showModal={showDetailModal}
        setShowModal={setShowDetailModal}
        order={selectedOrder}
        formatDate={formatDate}
        renderPaymentMethodIcon={renderPaymentMethodIcon}
      />
    </UIPage>
  );
};

export default Orders;
